import { useState } from 'react';
import { Workflow, GitBranch } from 'lucide-react';
import Automations from './Automations';
import Sequences from './Sequences';

const TABS = [
  { key: 'journeys', label: 'Journeys', icon: Workflow, hint: 'Triggered: when X happens → do Y' },
  { key: 'sequences', label: 'Email sequences', icon: GitBranch, hint: 'Multi-step follow-up drips' },
];

/**
 * Single "Automations" home merging the two previously-separate areas:
 *  - Journeys (event-triggered automations)
 *  - Email sequences (multi-step follow-up drips)
 */
export default function AutomationsHub() {
  const [tab, setTab] = useState('journeys');
  return (
    <div data-testid="automations-hub">
      <div className="flex items-center gap-2 border-b border-gray-200 px-6 lg:px-10 pt-6">
        {TABS.map((t) => {
          const Icon = t.icon;
          const active = tab === t.key;
          return (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              data-testid={`automations-tab-${t.key}`}
              title={t.hint}
              className={`inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors ${
                active ? 'border-blue-600 text-blue-700' : 'border-transparent text-gray-500 hover:text-gray-800'
              }`}
            >
              <Icon className="w-4 h-4" /> {t.label}
            </button>
          );
        })}
      </div>
      {tab === 'journeys' ? <Automations /> : <Sequences />}
    </div>
  );
}
